import { accountContract } from "@common/contracts/account.contract";
import { GetAccountsResponse } from "@common/types/domains/accounting/account";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const accountContractClient = getBackendAPIClient(accountContract);

export async function getAccounts(
    entityId: number,
): Promise<GetAccountsResponse> {
    const response = await accountContractClient.getAccountsForEntity({
        params: { entityId },
    });

    if (response.status !== 200) {
        throw new Error("Failed to fetch accounts");
    }

    return response.body;
}
